import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/constants";

const GuaranteeSection = () => (
  <section id="garantia" className="bg-gradient-hero py-16 md:py-24">
    <div className="container">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        className="mx-auto max-w-2xl text-center"
      >
        <ShieldCheck className="mx-auto mb-6 h-16 w-16 text-primary" />
        <h2 className="mb-4 text-2xl font-extrabold text-primary-foreground sm:text-3xl md:text-4xl">
          Garantia <span className="text-gradient-orange">Total</span>
        </h2>
        <p className="mb-8 text-lg leading-relaxed text-primary-foreground/80">
          Todos os nossos produtos e serviços possuem garantia total.
          <br />
          <strong className="text-primary-foreground">
            Se você não gostar, devolvemos 100% do valor investido.
          </strong>
        </p>
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 rounded-lg bg-gradient-orange px-8 py-4 text-base font-bold text-primary-foreground shadow-button transition-transform hover:scale-105"
        >
          Comece Sem Risco
        </a>
      </motion.div>
    </div>
  </section>
);

export default GuaranteeSection;
